import { create } from 'zustand';

const STORAGE_KEY = 'satutim_playground_api_key';
const EXPIRY_KEY = 'satutim_playground_api_key_exp';

interface State {
    key: string | null;
    exp: number | null;
    setKey: (key: string, exp?: number) => void;
    clearKey: () => void;
    loadFromStorage: () => void;
}

export const useApiKey = create<State>((set) => ({
    key: null,
    exp: null,
    setKey: (key, exp) => {
        try {
            localStorage.setItem(STORAGE_KEY, key);
            if (exp) localStorage.setItem(EXPIRY_KEY, String(exp));
        } catch { /* private mode */ }
        set({ key, exp: exp || null });
    },
    clearKey: () => {
        try {
            localStorage.removeItem(STORAGE_KEY);
            localStorage.removeItem(EXPIRY_KEY);
        } catch { /* */ }
        set({ key: null, exp: null });
    },
    loadFromStorage: () => {
        try {
            const k = localStorage.getItem(STORAGE_KEY);
            const e = localStorage.getItem(EXPIRY_KEY);
            if (k) set({ key: k, exp: e ? parseInt(e, 10) : null });
        } catch { /* */ }
    },
}));
